import { createPortal } from "react-dom";
import { useLocation } from "react-router-dom";
import { getAssetUrl } from "../../utils/assetUrl";
import "./ThnBackground.css";

export default function ThnBackground() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;

  return createPortal(
    <div className="thn-bg" aria-hidden>
      <img
        className="thn-bg__img"
        src={getAssetUrl("/assets/thn/bg-matrix.png")}
        alt=""
        width={1920}
        height={1080}
      />
    </div>,
    document.body
  );
}
